export default __webpack_public_path__ + "static/media/OasisPokerwinTable.37fab0ea.webp";